import { extendTailwindMerge } from "tailwind-merge";
import { clsx, type ClassValue } from "clsx";

const twMerge = extendTailwindMerge({ prefix: "ghw-" });

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
